import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TablaRubricaState {
	isSaved: boolean;
	isDirty: boolean;
}

const initialState: TablaRubricaState = { isSaved: false, isDirty: false };

const tablaRubricaStatusSlice = createSlice({
	name: 'tablaRubricaStatus',
	initialState,
	reducers: {
		setTablaRubricaStatus: (state, action: PayloadAction<TablaRubricaState>) => {
			return action.payload;
		},
		setSavedTablarubricaStatus: () => {
			return { isDirty: false, isSaved: true };
		},
		setDirtyTablaRubricaStatus: () => {
			return { isDirty: true, isSaved: false };
		},
		resetTablaRubricaStatus: () => {
			return initialState;
		}
	}
});

export const {
	setTablaRubricaStatus,
	setSavedTablarubricaStatus,
	resetTablaRubricaStatus,
	setDirtyTablaRubricaStatus
} = tablaRubricaStatusSlice.actions;

export default tablaRubricaStatusSlice.reducer;
